import { useState, useEffect } from "react";
import "./App.css";
import useTiltEffect from "./useTiltEffect";
import Topbar from "./Topbar";
import AboutMeModal from "./AboutMeModal";
import paper from "./assets/paper.png";
import oval from "./assets/oval.png";
import star from "./assets/star.png";
import disk from "./assets/disk.png";
import cube from "./assets/cube.png";
import Figure from "./Figure";
import MyProjectsSection from "./MyProjectsSection";

function style() {
  // return
  return {
    animation: `idle infinite ${
      Math.random() * 2 + 3
    }s cubic-bezier(0.4, 0, 0.6, 1)`,
  };
}

function App() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [showAboutMe, setShowAboutMe] = useState(false);
  const { position, handleMouseMove, resetRotation } = useTiltEffect();

  useEffect(() => {
    const handleLoad = () => setIsLoaded(true);

    if (document.readyState === "complete") {
      setIsLoaded(true);
      return;
    }

    window.addEventListener("load", handleLoad);
    return () => window.removeEventListener("load", handleLoad);
  }, []);

  return (
    <>
      <AboutMeModal open={showAboutMe} onClose={() => setShowAboutMe(false)} />
      <div
        className={"app" + (showAboutMe ? " modal-blur" : "")}
        onMouseMove={handleMouseMove}
        onMouseLeave={resetRotation}
      >
        {/* Прелоадер */}
        <div className={`preloader ${isLoaded ? "hidden" : ""}`}>
          <div className="loader">
            {document.readyState === "interactive"
              ? "Loading..."
              : "Just a little bit..."}
          </div>
        </div>
        {/* Конетнт */}

        <img id="paper" src={paper}></img>
        <div className="coords">
          X:{(position.x / window.innerWidth * 100).toFixed(0) + ""} Y:
          {(position.y / window.innerHeight* 100).toFixed(0) + ""}
        </div>
        <div className="topbar">
          <Topbar onInfoClick={() => setShowAboutMe(true)} />
        </div>

        <div className={`content ${isLoaded ? "visible" : ""}`}>
        <div className="title">
          <span
            className="header"
            // style={{
            //   transform: `translateY(${rotation.x * -0.5}px) translateX(${
            //     rotation.y * -0.5
            //   }px)`,
            // }}
          >
            Digidro
          </span>
          <div className="figures">
            {/* <img id="oval" className="figure" src={oval} onMouseMove={handleMouseMove} style={tiltStyle}></img> */}
            <Figure img={oval} position={position} x={620} y={550} _id="oval" />
            <Figure img={star} position={position} x={800} y={500} _id="star" />
            <Figure img={disk} position={position} x={1150} y={620} _id="disk" />
            <Figure img={cube} position={position} x={1420} y={480} _id="cube" />
          </div>
          <span
            className="subheader"
            // style={{
            //   transform: `translateY(${rotation.x * -0.5}px) translateX(${
            //     rotation.y * -0.5
            //   }px)`,
            // }}
          >
            3D Artist ▴ Designer ▴ Developer
          </span>
        </div>
      </div>
    </div>
      <MyProjectsSection />
    </>
  );
}

export default App;
